import { get, post, put, del } from './utils';

export default class Api {
    constructor(urlV4) {
        this.url = urlV4;
    }

    /* authentication */

    login = (credentials) => post(`${this.url}/authenticate/v1/login`, credentials);

    loginInfo = (credentials) => {
        return post(`${this.urlBackend2}/fmanager2.ASMX/GetUserLoginInfo`, credentials, {
            'Content-Type': 'application/json',
        }).then((x) => x.Response);
    };

    login2fa = (credentials) => post(`${this.url}/2fa/v1/login`, credentials);

    tokenByToken = (data) => post(`${this.url}/authenticate/v1/byToken`, data);

    switchImplementation = (implId) => {
        const data = {
            implementation: `${implId}`,
        };
        return put(`${this.url}/config/v1/changeImplementation`, data);
    };

    changeScope = (scope = []) => {
        return post(`${this.url}/authentication/v1/scope/change`, {
            scope,
        });
    };

    changeSandbox = (implId) =>
        put(`${this.url}/config/v1/changeSandbox`, {
            implementationId: `${implId}`,
            sandbox: true,
        });

    getCfmAutoLogin = () => get(`${this.url}/authentication/admin/v1/autoLogin`);

    getLoggedUserData = () => get(`${this.url}/user/v1/auth`);

    /* widgets */

    getWidgetGuid = () => get(`${this.url}/widgets/v1/guid`);

    getWidgets = (entity) => get(`${this.url}/widgets/v1?type=${entity}`);

    getWidget = (id) => get(`${this.url}/widgets/v1/${id}`);

    getWidgetTypes = () => get(`${this.url}/widgets/entities`); /* need the route */

    createWidget = (data) => post(`${this.url}/widgets/v1`, data);

    updateWidget = (id, data) => put(`${this.url}/widgets/v1/${id}`, data);

    activateWidget = (id, data) => put(`${this.url}/widgets/v1/${id}/activate`, data);

    deleteWidget = (id) => del(`${this.url}/widgets/v1/${id}`, {});

    // Images
    getWidgetImageUploadUrl = (id) => get(`${this.url}/widgets/v1/images/${id}/upload`);

    getWidgetImageDownloadUrl = (id) => get(`${this.url}/widgets/v1/images/${id}/download`);

    addWidgetImage = (id, order) => post(`${this.url}/widgets/v1/${id}/images`, order);

    uploadWidgetImage = (url, image) => put(url, image);

    deleteWidgetImage = (id) => del(`${this.url}/widgets/v1/images/${id}`);

    /* Fragments (Widgets, Forms) */
    getFragmentCodeUrl = (guid) => get(`${this.url}/fragments/v1/${guid}/upload`);

    uploadFragmentCode = (url, code) => put(url, code);

    // Unused, but let's leave it here just in case for the future changes
    // downloadFragmentCode = guid => get(`${this.url}/fragments/v1/${guid}/download`);

    /* Forms */
    getForm = (id) => get(`${this.url}/forms/v1/${id}/templates`);

    getForms = () => get(`${this.url}/forms/v1/templates`);

    createForm = (data) => post(`${this.url}/forms/v1/templates`, data);

    updateForm = (id, data) => put(`${this.url}/forms/v1/${id}/templates`, data);

    deleteForm = (id) => del(`${this.url}/forms/v1/${id}/templates`);

    /* Api keys */
    getApiKey = (id) => get(`${this.url}/key/v1/${id}`);

    getApiKeys = () => get(`${this.url}/key/v1`);

    getMapKeys = () => get(`${this.url}/key/v1/maps`);

    getApiKeysUsagePlans = () => get(`${this.url}/key/v1/usagePlans`);

    createApiKey = (values) => post(`${this.url}/key/v1`, values);

    deleteApiKey = (id) => del(`${this.url}/key/v1/${id}`);

    updateApiKey = (id, values) => put(`${this.url}/key/v1/${id}`, values);

    getApiUsagePlans = () => get(`${this.url}/key/v1/usagePlans`);

    getApiKeyExternalProviders = () => get(`${this.url}/key/v1/providers`);

    createFtpUser = () => post(`${this.url}/implementation/v1/implementation/ftp`);

    getFtpUser = () => get(`${this.url}/implementation/v1/implementation/ftp`);

    deleteFtpUser = () => del(`${this.url}/implementation/v1/implementation/ftp`);

    /* ======================================
   * Implementation
   ===================================== */
    getImplementations = (q, filter, licenses) => {
        return get(`${this.url}/implementation/v1/implementation/list`, {
            q,
            filter,
            plan: licenses?.join(','),
        });
    };

    getImplementationDetail = () => get(`${this.url}/implementation/v1/implementation/detail`);

    createFavorite = (id) => {
        const data = { implementation: id.toString() };
        return post(`${this.url}/implementation/v1/implementation/favorite`, data);
    };

    removeFavorite = (id) => del(`${this.url}/implementation/v1/implementation/favorite/${id}`, {});

    getFavorites = () => get(`${this.url}/implementation/v1/implementation/favorite`);

    getLicenses = () => get(`${this.url}/implementation/v1/license`);

    /* parameters */

    getParameters = () => get(`${this.url}/implementation/v1/parameter`);

    getParameter = (key, section) =>
        get(`${this.url}/implementation/v1/parameter/${section}/${key}`);

    updateParameter = (key, section, data) =>
        put(`${this.url}/implementation/v1/parameter/${section}/${key}`, data);

    /* sandbox */

    getSandboxState = () => get(`${this.url}/sandbox/v1/state`);

    createSandbox = () => post(`${this.url}/sandbox/v1/create`, {});

    getSandbox = () => get(`${this.url}/sandbox/v1/sandbox`);

    /* fields */

    getFieldList = (entity) => get(`${this.url}/fields/v1/${entity}`);

    getTabs = (entity) => get(`${this.url}/fields/v1/${entity}/tab`);

    getExtraFields = (entity) => get(`${this.url}/fields/v1/${entity}/extra`);

    getExtraFieldEntities = () => get(`${this.url}/fields/v1/extra/entities`);

    getStandardField = (id) => get(`${this.url}/fields/v1/standard/${id}`);

    getExtraField = (id) => get(`${this.url}/fields/v1/extra/${id}`);

    getExtraFieldTab = (id) => get(`${this.url}/fields/v1/tab/${id}`);

    createExtraField = (data) => post(`${this.url}/fields/v1/extra`, data);

    createExtraFieldTab = (data) => post(`${this.url}/fields/v1/tab`, data);

    updateStandardField = (id, data) => put(`${this.url}/fields/v1/standard/${id}`, data);

    updateExtraFieldTab = (id, data) => put(`${this.url}/fields/v1/tab/${id}`, data);

    deleteExtraFieldTab = (id) => del(`${this.url}/fields/v1/tab/${id}`, {});

    updateExtraField = (id, data) => put(`${this.url}/fields/v1/extra/${id}`, data);

    deleteExtraField = (id) => del(`${this.url}/fields/v1/extra/${id}`, {});

    getCrudSchema = (tableName) => get(`${this.url}/fields/v1/${tableName}/crudSchema`);

    /* users */
    getImplSummary = () => get(`${this.url}/user/v1/implementationSummary`);

    getUsers = ({ page = 0, filters = {} }) =>
        get(
            `${this.url}/user/v1`,
            {
                page,
                ...filters,
            },
            { count: 100 },
        );

    getUsersHierachy = () => get(`${this.url}/user/v1/hierachy`);

    getUser = (id) => get(`${this.url}/user/v1/${id}`);

    getUserPermissions = (id) => get(`${this.url}/user/v1/${id}/permissions`);

    getUserPermissionsDraft = (roles = []) =>
        get(`${this.url}/roles/v2/permissionsDraft?rolesId[]=${roles.join(',')}`);

    getRoleByPermissionId = (id) => get(`${this.url}/permissions/v1/${id}/roles`);

    getRoleByPermissionAndUserId = (id, userId) =>
        get(`${this.url}/permissions/v1/${id}/user/${userId}/roles`);

    impersonateUser = (id) => get(`${this.url}/user/v1/${id}/impersonate`);

    toggleActivateUser = (id, data) => put(`${this.url}/user/v1/${id}/activate`, data);

    getPasswordPolicies = () => get(`${this.url}/user/v1/getPasswordPolicies`);

    getSSOProvider = () => get(`${this.url}/implementation/v1/implementation/ssoProvider`);

    createUser = (data) => post(`${this.url}/user/v1`, data);

    updateUser = (id, data) => put(`${this.url}/user/v1/${id}`, data);

    deleteUser = (id) => del(`${this.url}/user/v1/${id}`, {});

    getUserSchema = () => get(`${this.url}/user/v1/schema`);

    sendEmailPassword = (id) => get(`${this.url}/user/v1/${id}/sendEmailPassword`);

    getCountryCodes = () => get(`${this.url}/user/v1/prefix`);

    /* value list */
    getList = (list, params, count = 500) =>
        get(`${this.url}/valuelist/v1/${list}`, params, { count });

    /* search */
    autoCompleteSearch = (list, params) => get(`${this.url}/search/v1/fuzzySearch/${list}`, params);

    /* roles */

    getRoles = () => get(`${this.url}/roles/v2`);

    /* literals management */
    getLiteralsByImpl = (page, filters, count) =>
        get(
            `${this.url}/literals/v1`,
            {
                page,
                search: filters,
            },
            {
                count,
            },
        );

    updateLiteralsByImpl = (data) =>
        put(
            `${this.url}/literals/v1`,
            data,
            { count: data.length },
            {
                timeout: 60 * 1000 * 10, // 10 min
            },
        );

    /* Permissions */
    getPermissions = () => get(`${this.url}/permissions/v1/functionality`);

    /* Crons */
    getCronStatus = (operation) => get(`${this.url}/cron/v1/enabled/${operation}`);

    /* Device Cache */
    getDeviceCache = () => get(`${this.url}/key/v1/deviceCache`);

    setDeviceCache = (data) => post(`${this.url}/key/v1/deviceCache`, data);
}
